/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Ai_DescriptionInputs */

const en_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how to select different models, use Leo on a mobile device, connect Leo with Brave Talk, access or disable the sidebar, cancel a premium subscription, and more.`)
};

const id_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari cara memilih model yang berbeda, menggunakan Leo di perangkat mobile, menghubungkan Leo dengan Brave Talk, mengakses atau menonaktifkan sidebar, membatalkan langganan premium, dan banyak lagi.`)
};

const ms_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari bagaimana untuk memilih model yang berbeza, guna Leo pada peranti mudah alih, sambungkan Leo dengan Brave Talk, akses atau matikan bar sisi, batalkan langganan premium, dan banyak lagi.`)
};

const ca_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprèn com seleccionar diferents models, utilitzar Leo en un dispositiu mòbil, connectar Leo amb Brave Talk, accedir o deshabilitar la barra lateral, cancel·lar una subscripció premium i molt més.`)
};

const cs_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zjistěte, jak vybrat různé modely, používat Lea na mobilním zařízení, připojit Lea k Brave Talk, přistupovat k postrannímu panelu nebo jej zakázat, zrušit prémiové předplatné a další.`)
};

const da_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær, hvordan du vælger forskellige modeller, bruger Leo på en mobilenhed, forbinder Leo med Brave Videoopkald, får adgang til eller deaktiverer sidepanelet, annullerer et premium-abonnement og mere.`)
};

const de_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie, wie Sie verschiedene Modelle auswählen, Leo auf einem Mobilgerät verwenden, Leo mit Brave Talk verbinden, auf die Seitenleiste zugreifen oder sie deaktivieren, ein Premium-Abonnement kündigen und mehr.`)
};

const et_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Õppige, kuidas valida erinevaid mudeleid, kasutada Leot mobiilseadmes, ühendada Leo Brave Talkiga, pääseda juurde või keelata külgriba, tühistada premiumi tellimus ja palju muud.`)
};

const es_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprende cómo seleccionar diferentes modelos, usar Leo en un dispositivo móvil, conectar Leo con Brave Talk, acceder o desactivar la barra lateral, cancelar una suscripción premium y más.`)
};

const fr_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez comment sélectionner différents modèles, utiliser Leo sur un appareil mobile, connecter Leo à Appels Brave, accéder à la barre latérale ou la désactiver, annuler un abonnement Premium, et plus encore.`)
};

const hr_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saznajte kako odabrati različite modele, koristiti Lea na mobilnom uređaju, povezati Lea s Brave Talkom, pristupiti ili onemogućiti bočnu traku, otkazati premium pretplatu i više.`)
};

const it_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri come scegliere i modelli, utilizzare Leo su un dispositivo mobile, collegare Leo a Videoconferenze Brave, accedere o disattivare la barra laterale, annullare un abbonamento premium e altro ancora.`)
};

const lv_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzziniet, kā izvēlēties citu modeli, lietot Leo mobilajā ierīcē, savienot Leo ar Brave Talk, piekļūt vai atslēgt sānjoslu, atcelt Premium abonementu un citus padomus.`)
};

const lt_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sužinokite, kaip pasirinkti skirtingus modelius, naudoti Leo mobiliuoju įrenginiu, prisijungti Leo su Brave Talk, pasiekti ar išjungti šoninę juostą, atšaukti premium prenumeratą ir daugiau.`)
};

const hu_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanulja meg, hogyan választhat különböző modelleket, használhatja Leót mobil eszközön, csatlakoztathatja Leót a Brave Talk-hoz, elérheti vagy letilthatja az oldalsávot, lemondhatja a prémium előfizetést és még sok mást.`)
};

const nl_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer hoe je verschillende modellen selecteert, Leo gebruikt op een mobiel apparaat, Leo verbindt met Brave Talk, toegang krijgt tot of de sidebar uitschakelt, een premium abonnement annuleert en meer.`)
};

const nb_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finn ut hvordan du velger forskjellige modeller, bruker Leo på en mobilenhet, kobler Leo til Brave Talk, aktiverer og deaktiverer sidepanelet, sier opp et Premium-abonnement, og mye mer.`)
};

const pl_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz się, jak wybierać różne modele, korzystać z Leo na urządzeniu mobilnym, połączyć Leo z Brave Talk, uzyskać dostęp do paska bocznego lub go wyłączyć, anulować subskrypcję premium i nie tylko.`)
};

const pt_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba como selecionar diferentes modelos, usar o Leo em um dispositivo móvel, conectar o Leo ao Brave Talk, acessar ou desativar a barra lateral, cancelar uma assinatura premium e muito mais.`)
};

const ro_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aflați cum să selectați diferite modele, să utilizați Leo pe un dispozitiv mobil, să conectați Leo cu Brave Talk, să accesați sau să dezactivați bara laterală, să anulați un abonament premium și multe altele.`)
};

const sk_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dozviete sa, ako vybrať rôzne modely, používať Leo na mobilnom zariadení, pripojiť Leo k Brave Talk, pristupovať alebo vypnúť bočný panel, zrušiť prémiové predplatné a ďalšie.`)
};

const sl_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naučite se, kako izbrati različne modele, uporabljati Leo na mobilni napravi, povezati Leo z Brave Talk, dostopati do ali onemogočiti stransko vrstico, preklicati premium naročnino in še več.`)
};

const fi_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opi lisää eri mallien valitsemisesta, Leon käyttämisestä mobiililaitteella, Leon yhdistämisestä Brave Talkiin, sivupalkin käyttämisestä tai poistamisesta käytöstä, premium-tilauksen peruuttamisesta ja paljon muuta.`)
};

const sv_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lär dig hur du väljer olika modeller, använder Leo på en mobil enhet, kopplar Leo med Brave Samtal, kommer åt eller inaktiverar sidofältet, avslutar en premiumprenumeration och mer.`)
};

const vi_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hiểu cách chọn các mô hình khác nhau, sử dụng Leo trên thiết bị di động, kết nối Leo với Brave Talk, truy cập hoặc tắt thanh bên, hủy đăng ký cao cấp, và nhiều hơn nữa.`)
};

const tr_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farklı modelleri nasıl seçeceğinizi, Leo'yu mobil cihazda nasıl kullanacağınızı, Leo'yu Brave Talk ile nasıl bağlayacağınızı, kenar çubuğuna nasıl erişip devre dışı bırakacağınızı, premium aboneliği iptal etmeyi ve daha fazlasını öğrenin.`)
};

const el_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθετε πώς να επιλέξετε διαφορετικά μοντέλα, να χρησιμοποιήσετε το Leo σε κινητή συσκευή, να συνδέσετε το Leo με το Brave Talk, να αποκτήσετε πρόσβαση ή να απενεργοποιήσετε τη πλαϊνή μπάρα, να ακυρώσετε μια premium συνδρομή και πολλά άλλα.`)
};

const bg_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Научете как да изберете различни модели, използвате Leo на мобилно устройство, свържете Leo с Brave Talk, получите достъп или деактивирате страничната лента, анулирате премиум абонамент и други.`)
};

const ru_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнайте, как выбрать различные модели, использовать Leo на мобильном устройстве, подключить Leo к Brave Talk, получить доступ или отключить боковую панель, отменить премиальную подписку и многое другое.`)
};

const sr_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сазнајте како да изаберете друге моделе, да користите Leo на мобилном уређају, повежете Leo са Brave Talk-ом, приступите или онемогућите бочну траку, отказате премиум претплату и још много тога.`)
};

const uk_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дізнайтеся, як вибрати різні моделі, використовувати Leo на мобільному пристрої, підключити Leo до Brave Talk, отримати доступ або відключити бічну панель, скасувати преміум-підписку та багато іншого.`)
};

const ka_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეიტყვეთ, როგორ აირჩიოთ სხვადასხვა მოდელებიდან, გამოიყენოთ „Leo“ მობილურზე, დაუკავშირდეთ „Leo“-ს Brave Talk-ს, გამოიყენოთ ან გაათიშოთ გვერდითი ზოლი, გააუქმოთ პრემიუმ გამოწერა და სხვა.`)
};

const hi_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जानें कि विभिन्न मॉडलों का चयन कैसे करें, मोबाइल डिवाइस पर Leo का उपयोग कैसे करें, Leo को Brave Talk के साथ कैसे कनेक्ट करें, साइडबार का एक्सेस या निष्क्रिय कैसे करें, एक प्रीमियम सदस्यता रद्द करें, और अधिक।`)
};

const th_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้วิธีเลือกโมเดลที่แตกต่าง, ใช้ Leo บนอุปกรณ์มือถือ, เชื่อมต่อ Leo กับ Brave Talk, เข้าถึงหรือปิดการใช้งานแถบด้านข้าง, ยกเลิกการสมัครพรีเมี่ยม และอื่น ๆ`)
};

const ko_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다른 모델을 선택하는 방법, 모바일 기기에서 레오를 사용하는 방법, Brave Talk와 레오를 연결하는 방법, 사이드바에 액세스하거나 사이드바를 비활성화하는 방법, 프리미엄 구독을 취소하는 방법 등을 알아보세요.`)
};

const zh_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解如何选择不同的模型，在移动设备上使用 Leo，将 Leo 与 Brave Talk 连接，访问或禁用侧边栏，取消高级订阅等等。`)
};

const zh_tw_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瞭解如何選擇不同模型、在行動裝置上使用 Leo、將 Leo 與 Brave 通話連結、開啟或停用側邊欄、取消高級版訂閱等操作。`)
};

const ja_leo_ai_description = /** @type {(inputs: Leo_Ai_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さまざまなモデルを選択する方法、モバイルデバイスでLeoを使用する方法、LeoをBrave Talkと接続する方法、サイドバーにアクセスまたは無効にする方法、プレミアムサブスクリプションのキャンセル方法などを学びます。`)
};

/**
* | output |
* | --- |
* | "Learn how to select different models, use Leo on a mobile device, connect Leo with Brave Talk, access or disable the sidebar, cancel a premium subscription, ..." |
*
* @param {Leo_Ai_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_ai_description = /** @type {((inputs?: Leo_Ai_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Ai_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_ai_description(inputs)
	if (locale === "ms") return ms_leo_ai_description(inputs)
	if (locale === "ca") return ca_leo_ai_description(inputs)
	if (locale === "cs") return cs_leo_ai_description(inputs)
	if (locale === "da") return da_leo_ai_description(inputs)
	if (locale === "de") return de_leo_ai_description(inputs)
	if (locale === "et") return et_leo_ai_description(inputs)
	if (locale === "es") return es_leo_ai_description(inputs)
	if (locale === "fr") return fr_leo_ai_description(inputs)
	if (locale === "hr") return hr_leo_ai_description(inputs)
	if (locale === "it") return it_leo_ai_description(inputs)
	if (locale === "lv") return lv_leo_ai_description(inputs)
	if (locale === "lt") return lt_leo_ai_description(inputs)
	if (locale === "hu") return hu_leo_ai_description(inputs)
	if (locale === "nl") return nl_leo_ai_description(inputs)
	if (locale === "nb") return nb_leo_ai_description(inputs)
	if (locale === "pl") return pl_leo_ai_description(inputs)
	if (locale === "pt") return pt_leo_ai_description(inputs)
	if (locale === "ro") return ro_leo_ai_description(inputs)
	if (locale === "sk") return sk_leo_ai_description(inputs)
	if (locale === "sl") return sl_leo_ai_description(inputs)
	if (locale === "fi") return fi_leo_ai_description(inputs)
	if (locale === "sv") return sv_leo_ai_description(inputs)
	if (locale === "vi") return vi_leo_ai_description(inputs)
	if (locale === "tr") return tr_leo_ai_description(inputs)
	if (locale === "el") return el_leo_ai_description(inputs)
	if (locale === "bg") return bg_leo_ai_description(inputs)
	if (locale === "ru") return ru_leo_ai_description(inputs)
	if (locale === "sr") return sr_leo_ai_description(inputs)
	if (locale === "uk") return uk_leo_ai_description(inputs)
	if (locale === "ka") return ka_leo_ai_description(inputs)
	if (locale === "hi") return hi_leo_ai_description(inputs)
	if (locale === "th") return th_leo_ai_description(inputs)
	if (locale === "ko") return ko_leo_ai_description(inputs)
	if (locale === "zh") return zh_leo_ai_description(inputs)
	if (locale === "zh-tw") return zh_tw_leo_ai_description(inputs)
	if (locale === "ja") return ja_leo_ai_description(inputs)
	return en_leo_ai_description(inputs)
});